import React, { Component } from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'
import colors from '../../utils/colors'
import media from '../../utils/media'
import {
  Box,
  SemanticList,
  Nav,
  Link,
  FlexibleLink,
} from '../../components/Layout'

const navLink = css`
  &:hover {
    color: #1c86f2;
  }
`

const NavLink = ({ to, children, href }) => {
  return (
    <li>
      <FlexibleLink mx={2} to={to} color="black" className={navLink}>
        {children}
      </FlexibleLink>
    </li>
  )
}

class Navigation extends Component {
  render() {
    return (
      <Nav fontSize={3}>
        <SemanticList display="flex" ml="auto" px={[3, 3, 4]} my={3}>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/manifesto">Manifesto</NavLink>
          <NavLink href="/source" target="_blank">
            Source
          </NavLink>
        </SemanticList>
      </Nav>
    )
  }
}

export default Navigation



// WEBPACK FOOTER //
// ./src/components/Navigation/index.js